function useStyles() {
    return {
        container: {
            padding: '24px 0px 0px',
            height: '100%',
            '& .MuiGrid-item': {
                height: '100%',
            },
            '& .background': {
                backgroundColor: 'blue.100',
                padding: 3,
                height: '100%',
            },
            '& .flex-wrap': { flexWrap: 'wrap' },
            '& .flex': { display: 'flex' },
            '& .flex-col': { flexDirection: 'column' },
            '& .item-center': { alignItems: 'center' },
            '& .gap-2': { gap: 2 },
            '& .gap-4': { gap: 4 },
            '& .MuiTextField-root': { backgroundColor: 'white' },
            '& .relative': { position: 'relative ' },
            '& .pb-22': { paddingBottom: '84px' }
        },
        btnFooter: {
            position: 'absolute',
            bottom: '24px',
            right: '24px'
        },
        drawer: {
            width: '450px',
            padding: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        fields: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        textField: {
            flex: '1 0 100px'
        },
        filter: {
            flex: '0 1 100px'
        }
    }
}

export { useStyles }